module.exports = __webpack_public_path__ + "static/media/main_logo.21bd38ed.png";